import { useMemo, useState } from "react"
import { Form, ModalId, useUIActions, FormField, FieldType, O, FieldValue } from "../../../../../features/ui"
import { Data } from "../../../../../features/data-types"
import { Discount } from "../../../types"

type Props = {
    defaultData?: Partial<Discount>
    usedNames: string[]
    onSubmit: (data: Partial<Discount>) => void
}

export const DiscountForm = (props: Props) => {
    const { defaultData, usedNames, onSubmit } = props
    const createMode = !defaultData

    const newData = useMemo(() => {
        let index = 1
        let name = `Bonif ${index}`
        while (usedNames.includes(name)) {
            name = `Bonif ${index++}`
        }
        return { name, yield: 5 }
    }, [usedNames])
    const [data, setData] = useState<O<Partial<Discount>>>(defaultData || newData)

    const { closeModal } = useUIActions()

    const validateName = (value?: Data) => defaultData?.name !== value?.name && usedNames.find(name => name === value?.name) ? 'El nombre ya existe' : null

    const onChangeName = (value?: FieldValue) => {
        setData({
            ...data,
            name: value as O<string>,
        })
    }

    const onChangeYield = (value?: FieldValue) => {
        setData({
            ...data,
            yield: value as O<number>,
        })
    }

    const fields: FormField[] = [
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Nombre',
            value: data?.name,
            focus: true,
            onChange: onChangeName,
            validate: validateName
        },
        {
            name: 'yield',
            type: FieldType.PERCENTAGE,
            label: 'Porcentaje',
            value: data?.yield,
            onChange: onChangeYield,
        },
    ]

    const handleSubmit = () => {
        onSubmit(data!)
        closeModal(ModalId.DISCOUNT_FORM)
    }

    const handleCancel = () => closeModal(ModalId.DISCOUNT_FORM)

    return (
        <Form
            formId="bonus-form"
            fields={fields}
            createMode={createMode}
            createLabel="Agregar"
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    )
}
